


import React, { useContext, useEffect } from "react";
// import images from "../utils/images";
import "../css/footer.css";
import '../css/header.css'
// import { GlobalDataContext } from "../GlobalDataContext";
const HeaderComponent = ({resultDate,page,bg,gradient,reference,smallref,portalid,kitid, kittype}) => {


//   const { kitid,SampleDate } = useContext(GlobalDataContext);
// const kitid = '123456789';
// const SampleDate = '2023-10-01';


const formatDate = (isoDate) => {

  if (!isoDate){return "-"}
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' }); // "May"
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

  return (
    <div className="header" 
    // style={{ background: gradient
    //   ? "linear-gradient(to right, #E9F7FF, #E6DEFF)"
    //   : bg || '#f6f3ff'}}
    style={{background:"#dac6b8"}}
      >
      <div className="part1">
      {/* <div className="icon">
        <img src={img} alt="" />
      </div> */}
      <div className="data" style={{display: "flex", flexDirection: "column", alignItems: "flex-start",justifyContent: "center"}}>
        {/* <div className="sampleid">Result Date : {formatDate(resultDate)}</div> */}
        <div className="sampleid">Patient Name : {resultDate}</div>
        <div className="sampleid">Sample ID : {kitid}</div>
        {/* <div className="sampleid">Sample ID : </div>
        <div className="sampleid">Result Date : </div> */}

      </div>
      </div>
      <div className="logopart">
        <img width={'55px'} style={{marginRight:"10px"}} src="/fitzlogo.png" alt="" />
        {kittype ? kittype : "FoodSensitivity Map"}
      </div>
      <div className="part2">
        <div className="data" style={{display: "flex", flexDirection: "column", alignItems: "flex-start",justifyContent: "center"}}>
        {/* <div className="sampleid">Result Date : {formatDate(resultDate)}</div> */}
        <div className="sampleid">DOB : {resultDate}</div>
        <div className="sampleid">Date : {kitid}</div>
        {/* <div className="sampleid">Sample ID : </div>
        <div className="sampleid">Result Date : </div> */}

      </div>
      </div>
    </div>
  );
};

export default HeaderComponent;
